import Ajax from '@/lib/ajax'
export default {
    /**
     * 创建积分活动
     * @param data 
     */
    addRewardPointActivity(data: any) {
        return Ajax.post(`/api/MarketingManagement/rewardPointActivity`, data)
    },
    /**
     * 更新积分活动
     * @param id 
     * @param data 
     */
    updateRewardPointActivity(id: string, data: any) {
        return Ajax.put(`/api/MarketingManagement/rewardPointActivity/${id}`, data)
    },
    /**
     * 获取积分活动信息
     * @param id 
     */
    getRewardPointActivity(id: string) {
        return Ajax.get(`/api/MarketingManagement/rewardPointActivity/${id}`)
    }
}